
  import React from "react"
  import Component from "/Users/pkimbrel/Local/Content/paulkimbrel-com/src/layouts/article.js"
  import data from "/Users/pkimbrel/Local/Content/paulkimbrel-com/.cache/json/layout-article.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/article.js